module.exports = "/_next/static/resources/single-95bebe687ab8b0e990d95c6ee2ca63a2.jpg";